import React, { useEffect, useRef } from 'react';
import { View, StyleSheet } from 'react-native';

const LoadingAnimation = ({ size = 600, style }) => {
  const containerRef = useRef(null);
  const animationRef = useRef(null);

  useEffect(() => {
    let mounted = true;
    
    if (containerRef.current) {
      // Dynamically import lottie-web for web platform
      import('lottie-web').then((lottie) => {
        if (!mounted) return;
        
        const animationData = require('../../assets/animation/floating-board.json');
        // Access the underlying DOM element from React Native Web View
        const viewElement = containerRef.current;
        const domNode = viewElement?._nativeNode || viewElement;
        
        if (domNode) {
          animationRef.current = lottie.default.loadAnimation({
            container: domNode,
            renderer: 'svg',
            loop: true,
            autoplay: true,
            animationData: animationData,
          });
          // Speed up the animation by 3x
          animationRef.current.setSpeed(3);
        }
      }).catch((error) => {
        console.error('Error loading lottie-web:', error);
      });
    }

    return () => {
      mounted = false;
      if (animationRef.current) {
        animationRef.current.destroy();
        animationRef.current = null;
      }
    };
  }, []);

  return (
    <View style={[styles.container, style]}>
      <View 
        ref={containerRef}
        style={[styles.animation, { width: size, height: size }]}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  animation: {
    width: 600,
    height: 600,
  },
});

export default LoadingAnimation;

